import type { ReactNode } from 'react'
import { useCanWriteOms, usePulseMe } from '@/app/auth/use-pulse-me'
import { Loader2 } from '@/components/icons'

/**
 * Keeps Operator-only route children unmounted until Vision confirms the
 * effective Pulse role. Unknown roles and failed access checks stay closed.
 */
export function OperatorRoute({ children }: { children: ReactNode }) {
  const me = usePulseMe()
  const canEnter = useCanWriteOms()

  if (me.isLoading) {
    return (
      <div className="flex items-center gap-2 py-16 text-[12.5px] text-[color:var(--muted-foreground)]">
        <Loader2 className="size-4 animate-spin" />
        Checking access…
      </div>
    )
  }

  if (!canEnter) {
    return (
      <div className="flex flex-col items-start gap-2 py-16">
        <h1 className="text-[15px] font-semibold">Not allowed</h1>
        <p className="text-[12.5px] text-[color:var(--muted-foreground)]">
          Only Operators, Config Managers, Admins, and Superadmins can access this operator
          workflow.
        </p>
      </div>
    )
  }

  return <>{children}</>
}
